/* ============================================================
   ÉKO '77 — HOME: LOVE LETTER, the lede that writes itself in

   Port of the `#lede` loop in the reference assets/js/site.js. The
   opening sentence starts at a pale resting tint and inks in word by
   word as it travels up the screen, with a soft leading edge a few
   words wide.

   Reference maths, kept exactly:
     from   = vh * 0.82        // starts as the line enters the lower third
     to     = vh * 0.28        // finished by the time it sits high
     p      = clamp((from - rect.top) / (from - to), 0, 1)
     head   = p * (words + 8)  // the leading edge runs ahead of the text
     word i = clamp((head - i) / 4, 0, 1)   // 4 words of feather
   The section publishes each word's value as --t; assets/x-letter.css
   turns it into a colour with color-mix. No colour is computed here.

   STILL STATES — the sentence is simply set at full strength, no
   listeners, when any of these hold:
     · prefers-reduced-motion: reduce (watched live, not read once);
     · the viewport is at or below data-narrow (700 in the reference —
       on a phone the whole lede is on screen at once, so there is no
       travel to animate against);
     · the merchant switched the effect off, in which case the section
       does not emit data-x-letter-lede at all and this file never sees
       the paragraph — the inked colour comes from CSS.

   Added on top of the reference, because a Shopify theme needs it:
     · the paragraphs are re-collected on shopify:section:load /
       :unload, so editing the copy in the theme editor re-wraps it;
     · wrapping is idempotent per element, so a re-collect on an
       untouched section does not nest spans;
     · whitespace text nodes are preserved as text nodes, so the words
       are still separated for selection, search and screen readers.

   The script is idempotent: one set of listeners no matter how many
   times a page requests it.
   ============================================================ */
(function () {
  'use strict';

  if (window.__xLetter) return;
  window.__xLetter = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ledes = [];
  var ticking = false;

  function clamp(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  /* wrap every word in its own span, recursing into elements so the
     hanging indent keeps its own <span> wrapper */
  function wrapWords(node) {
    var kids = Array.prototype.slice.call(node.childNodes);

    for (var i = 0; i < kids.length; i++) {
      var n = kids[i];

      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();

        n.nodeValue.split(/(\s+)/).forEach(function (token) {
          if (!token) return;

          if (/^\s+$/.test(token)) {
            frag.appendChild(document.createTextNode(token));
            return;
          }

          var word = document.createElement('span');
          word.className = 'x-letter__w';
          word.textContent = token;
          frag.appendChild(word);
        });

        node.replaceChild(frag, n);
      } else if (n.nodeType === 1 && n.className !== 'x-letter__w') {
        wrapWords(n);
      }
    }
  }

  function collect() {
    ledes = Array.prototype.slice
      .call(document.querySelectorAll('[data-x-letter-lede]'))
      .map(function (el) {
        if (!el.hasAttribute('data-x-letter-wrapped')) {
          wrapWords(el);
          el.setAttribute('data-x-letter-wrapped', '');
        }

        return {
          el: el,
          words: Array.prototype.slice.call(el.querySelectorAll('.x-letter__w')),
          narrow: parseInt(el.getAttribute('data-narrow'), 10) || 700
        };
      });

    paint();
  }

  function paint() {
    ticking = false;

    var vh = window.innerHeight;

    ledes.forEach(function (lede) {
      var still = reduced.matches || window.innerWidth <= lede.narrow;

      if (still) {
        lede.words.forEach(function (word) {
          word.style.setProperty('--t', 1);
        });
        return;
      }

      var top = lede.el.getBoundingClientRect().top;
      var from = vh * 0.82;
      var to = vh * 0.28;
      var progress = clamp((from - top) / (from - to), 0, 1);
      var head = progress * (lede.words.length + 8);

      lede.words.forEach(function (word, i) {
        word.style.setProperty('--t', clamp((head - i) / 4, 0, 1));
      });
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);

  if (reduced.addEventListener) {
    reduced.addEventListener('change', paint);
  } else if (reduced.addListener) {
    reduced.addListener(paint);
  }
})();
